import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConsultantDetailModal from "./ConsultantDetailModal";

const ConsultantDetail = () => {
  const { consultantId } = useParams();
  const navigate = useNavigate();

  return (
    <ConsultantDetailModal
      isOpen={true}
        consultantId={consultantId}
      onClose={() => navigate("/portal/asap-pilot/consultants")}
    />
  );
};

export default ConsultantDetail;
